import { Hash } from '.';

const jaIndex: Hash<string> = {
  'users': 'ユーザ',
  'folders': 'フォルダ',
  'books': 'ブック',
  'sheets': 'シート',
  'sheetInformations': 'シート情報',
  'palettes': 'パレット',
  'cardTemplates': 'カードテンプレート',
  'cardTemplateAttributes': 'カードテンプレート入力項目',
  'cardTemplateShapes': 'カードテンプレート図形',
  'cards': 'カード',
  'cardAttributes': 'カード入力項目',
  'cardShapes': 'カード図形',
  'memoCardContents': 'メモカード内容',
  'uiCardItems': 'UIモックアップカード項目',
  'drawCardContents': 'お絵かきカード内容',
  'uiCardSampleDatas': 'UIモックアップカードサンプルデータ',
  'cardCodeTemplates': 'カードコードテンプレート',
  'cardCodes': 'カードコード',
  'arrows': '矢印',
  'albums': 'アルバム',
  'images': '画像',
  'sheetTrees': 'シートツリー',
  'relationUserFolders': 'ユーザ・フォルダ関係',
  'relationUserBooks': 'ユーザ・ブック関係',
  'relationUserPalettes': 'ユーザ・パレット関係',
  'relationUserCardTemplates': 'ユーザ・カードテンプレート関係',
  'relationFolderBooks': 'フォルダ・ブック関係',
  'relationPaletteCardTemplates': 'パレット・カードテンプレート関係',
  'relationUserAlbums': 'ユーザ・アルバム関係',
  'relationUserImages': 'ユーザ・画像関係',
  'relationAlbumImages': 'アルバム・画像関係',
  'latelyCardTemplates': '最近使ったカードテンプレートリスト',
  'latelyImages': '最近使った画像リスト',
  'jointBooks': 'ブック共有情報',
  'palettePermissions': 'パレット使用許可設定',
  'cardTemplatePermissions': 'カードテンプレート使用許可設定',
  'jointPalettes': 'パレット共有情報',
  'statusJointPalettes': 'パレット共有ステータス',
  'standbyPaletteJoineds': '待機中パレット共有情報',
  'standbyCardTemplateJoineds': '待機中カードテンプレート共有情報',
  'standbyRelationPaletteCardTemplateJoineds': '待機中パレット・カードテンプレート関係共有情報',
  'standbyPalettePermissionJoineds': '待機中パレット使用許可設定共有情報',
  'standbyCardTemplatePermissionJoineds': '待機中カードテンプレート使用許可設定共有情報',
  'userConditions': 'ユーザ状態',
  'notes': 'ノート'
}

const codeToText = (code: string, lang: string): string => {
  if (lang === 'ja') {
    const res = jaIndex[code];
    if (res) return res;
    else return '';
  } else return '';
}

export default codeToText;
